/** Mensajes de error en los formularios */
export const ERR_TEXT_FIELD_REQUIRED = 'Dato requerido';
export const ERR_SELECT_FIELD_REQUIRED = 'Dato requerido';
export const ERR_DATE_FIELD_REQUIRED = 'Dato requerido';
export const ERR_RANGE_DATE_FIELD_REQUIRED = 'Dato requerido';
export const ERR_TIME_FIELD_REQUIRED = 'Dato requerido';
export const ERR_RADIO_FIELD_REQUIRED = 'Dato requerido';
export const ERR_CHECKBOX_FIELD_REQUIRED = 'Dato requerido';
export const ERR_SAMPLE_FIELD_REQUIRED = 'Dato requerido';
export const ERR_EMAIL_FIELD_FORMAT = 'Formato inválido';
export const ERR_FECHA_APERTURA_FECHA_CIERRE_FIELD_MAYOR =
  'La hora de apertura no puede ser mayor a la hora de cierre';

// import * as fieldMsgs from 'constants/formFieldsMessages';
// fieldMsgs.ERR_SELECT_FIELD_REQUIRED
